<template>
    <div class="container">
        <div class="nav_header">
            <h2>我的合同</h2>
        </div>

        <div class="toolbar">
            <div class="left">
                <el-radio-group v-model="status" class="item" @change="(e) => on_field_change(e, 'status')">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button label="success">已完成</el-radio-button>
                    <el-radio-button label="wait">待签署</el-radio-button>
                    <el-radio-button label="fail">签署失败</el-radio-button>
                </el-radio-group>
            </div>
            <div class="right">
                <el-input placeholder="搜索" v-model="wd">
                    <el-button slot="append" icon="el-icon-search" @click="on_search" type="primary"></el-button>
                </el-input>
            </div>
        </div>

        <div v-loading="loading">
            <el-table v-loading="loading" :data="data_source">
                <el-table-column label="签署状态" width="90" prop="status_text" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 'success'" type="success">{{ scope.row.status_text }}</el-tag>
                        <el-tag v-if="scope.row.status == 'fail'" type="danger">{{ scope.row.status_text }}</el-tag>
                        <el-tag v-if="scope.row.status == 'wait'" type="info">{{ scope.row.status_text }}</el-tag>
                        <!-- <el-tag v-if="scope.row.status == 2" type="warning">{{ scope.row.status_text }}</el-tag> -->
                    </template>
                </el-table-column>

                <el-table-column prop="contract_id" label="合同编号" width="200"> </el-table-column>

                <el-table-column prop="name" label="合同名称">
                    <div slot-scope="scope">
                        {{ scope.row.title }}
                    </div>
                </el-table-column>

                <el-table-column prop="created_at" label="创建时间" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.created_at | dateformat("YYYY-MM-DD HH:mm") }}
                    </template>
                </el-table-column>

                <el-table-column width="100" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button @click="on_preview(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="on_down(scope.row)" type="text" size="small">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
            style="text-align:center;margin-top:24px;"
            background
            layout="total,prev, pager, next"
            :total="pagination.total"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            @current-change="handle_current_change"
        >
        </el-pagination>
    </div>
</template>

<script>
    import moment from "moment";
    var requestUrl = "/finance/transaction";

    export default {
        data() {
            return {
                path: "/contract",
                data_source: [],
                loading: false,
                status: "",
            };
        },
        created() {
            // this.$store.commit("changeOwnActive", "finance-transaction");
            this.load();
            this.parse_query();
        },
        watch: {
            $route() {
                this.load();
                this.parse_query();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/contract?" + this.objectToQuery(this.$route.query))
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                            this.pagination = response.pagination;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            parse_query() {
                const query = this.$route.query;
                this.status = Object.prototype.hasOwnProperty.call(query, "status") ? query["status"] : "";
            },
            on_preview(record) {
                window.open(record.viewpdf_url);
            },
            on_down(record) {
                window.open(record.download_url);
            },
        },
    };
</script>

<style scoped>
    .card-slim {
        max-height: 400px;
    }

    .show-more {
        height: 100px;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        background: linear-gradient(#ffffffa8, white);
    }
</style>
